<template>
    <div class="form">
        <Form ref="info" :label-width="90">
            <!-- sass暂不支持线上 -->
            <field-group populateType="through" :rules="bankCardRules">
                <div class="title">线上支付</div>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="是否启用" prop="enabled ">
                            <i-switch
                                v-model="bankCard.enabled"
                                :true-value="1"
                                :false-value="0"
                            />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="收款方式" prop="collectMode">
                            <Select v-model="bankCard.collectMode" transfer>
                                <Option
                                    v-for="(item, index) in collectModeList"
                                    :value="item.id"
                                    :key="item.index"
                                >
                                    {{ item.text }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="是否有手续费" prop="hasFee">
                            <RadioGroup v-model="bankCard.hasFee">
                                <Radio :label="1">是</Radio>
                                <Radio :label="0">否</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="12" v-if="bankCard.hasFee">
                        <FormItem prop="serviceFee" label="手续费比例">
                            <input-number
                                v-model="bankCard.serviceFee"
                                placeholder
                                :min="0"
                                :max="100"
                            >
                                <span slot="append">%</span>
                            </input-number>
                        </FormItem>
                    </Col>
                </Row>
                <Divider />
            </field-group>
            <div v-if="offlinePayStatus != 'off'">
                <div class="title">线下支付</div>
                <Row :gutter="20">
                    <!-- 微信 -->
                    <Col span="12">
                        <field-group
                            populateType="through"
                            :rules="wechatRules"
                        >
                            <FormItem label="是否启用" prop="enabled ">
                                <i-switch
                                    v-model="wechat.enabled"
                                    :true-value="1"
                                    :false-value="0"
                                />
                            </FormItem>
                            <FormItem label="上传微信二维码" prop="attachments">
                                <preview-upload
                                    v-model="wechat.attachments"
                                    :format="imgSuffix"
                                    :maxNumber="1"
                                />
                            </FormItem>
                            <FormItem label="备注" prop="remark">
                                <Input v-model="wechat.remark" />
                            </FormItem>
                            <FormItem label="是否有手续费" prop="hasFee">
                                <RadioGroup v-model="wechat.hasFee">
                                    <Radio :label="1">是</Radio>
                                    <Radio :label="0">否</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem
                                v-if="wechat.hasFee"
                                prop="serviceFee"
                                label="手续费比例"
                            >
                                <input-number
                                    v-model="wechat.serviceFee"
                                    placeholder
                                    :min="0"
                                    :max="100"
                                >
                                    <span slot="append">%</span>
                                </input-number>
                            </FormItem>
                        </field-group>
                    </Col>
                    <!-- 支付宝 -->
                    <Col span="12">
                        <field-group
                            populateType="through"
                            :rules="alipayRules"
                        >
                            <FormItem label="是否启用" prop="enabled ">
                                <i-switch
                                    v-model="alipay.enabled"
                                    :true-value="1"
                                    :false-value="0"
                                />
                            </FormItem>
                            <FormItem
                                label="上传支付宝二维码"
                                prop="attachments"
                            >
                                <preview-upload
                                    v-model="alipay.attachments"
                                    :format="imgSuffix"
                                    :maxNumber="1"
                                />
                            </FormItem>
                            <FormItem label="备注" prop="remark">
                                <Input v-model="alipay.remark" />
                            </FormItem>
                            <FormItem label="是否有手续费">
                                <div>否</div>
                            </FormItem>
                        </field-group>
                    </Col>
                </Row>
            </div>
        </Form>
    </div>
</template>

<script>
import { collectSetting, collectView } from '@/api/setting'

import { currency, deepCopy } from '_u/helper.js'
import config from '@/config'

export default {
    name: 'c-receive-form',
    props: {
        houseIds: {
            type: [String, Number],
            default: '',
        },
        // 线下支付开关
        offlinePayStatus: {
            type: String,
            default: '',
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {},
            // 银行卡
            bankCard: {
                enabled: 0, // 是否启用
                collectType: '1', //收款类型
                collectMode: '', //收款方式
                hasFee: 1, //是否有手续费
                serviceFee: '', //手续费
                attachments: '', //附件
                remark: '', //备注
            },
            // 微信
            wechat: {
                enabled: 1, // 是否启用
                collectType: '2', //收款类型
                collectMode: '10', //收款方式
                hasFee: 1, //是否有手续费
                serviceFee: '', //手续费
                attachments: '', //附件
                remark: '', //备注
            },
            // 支付宝
            alipay: {
                enabled: 1, // 是否启用
                collectType: '3', //收款类型
                collectMode: '11', //收款方式
                hasFee: 0, //是否有手续费
                serviceFee: '', //手续费
                attachments: '', //附件
                remark: '', //备注
            },
            dict: {},
            collectModeList: [], //
            imgSuffix: config.upload.imgSuffix,
        }
    },
    methods: {
        fetch() {
            const list = this.houseIds.split(',')
            if (list.length === 1) {
                return collectView(this.houseIds)
            } else {
                return Promise.resolve()
            }
        },
    },
    computed: {
        // 线上支付校验
        bankCardRules() {
            let rules = {}

            if (this.bankCard.enabled == '1') {
                Object.assign(rules, {
                    collectMode: [{ required: true, message: '收款方式必填' }],
                    serviceFee: [{ required: true, message: '手续费比例必填' }],
                })
            }

            return rules
        },
        // 微信校验
        wechatRules() {
            let rules = {}

            if (this.wechat.enabled == '1') {
                Object.assign(rules, {
                    attachments: [{ required: true, message: '二维码必填' }],
                    serviceFee: [{ required: true, message: '手续费比例必填' }],
                })
            }

            return rules
        },
        // 支付宝校验
        alipayRules() {
            let rules = {}

            if (this.alipay.enabled == '1') {
                Object.assign(rules, {
                    attachments: [{ required: true, message: '二维码必填' }],
                })
            }

            return rules
        },
    },
    mounted() {
        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.fetch(),
                this.$dict.get(['collect_type', 'collect_mode']),
            ])
                .then((args) => {
                    const [view, group] = args
                    Object.assign(this.dict, group)
                    this.collectModeList = group?.collectMode
                        .toList()
                        .filter((v) => {
                            v.remark = JSON.safeParse(v.remark)
                            return v.remark.type === 'public'
                        })

                    const list = view?.data?.list || []
                    if (list.length) {
                        list.forEach((v) => {
                            v.serviceFee = (v.serviceFee * 100).toFixed(2)
                            v.enabled = v.enabled === 0 ? 0 : 1
                        })
                        this.bankCard =
                            list.find((v) => v.collectType === '1') || {}
                        this.wechat =
                            list.find((v) => v?.collectMode === '10') || {}
                        this.alipay =
                            list.find((v) => v?.collectMode === '11') || {}
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            this.$refs.info
                .validate()
                .then(() => {
                    const formate = {}
                    const list = []

                    list.push(deepCopy(this.bankCard))
                    list.push(deepCopy(this.wechat))
                    list.push(deepCopy(this.alipay))

                    list.forEach((v) => {
                        v.serviceFee = v.hasFee === 1 ? v.serviceFee / 100 : 0 //手续费
                    })
                    formate.houseIds = this.houseIds
                    formate.list = JSON.stringify(list)
                    return collectSetting(formate)
                })
                .then((res) => {
                    this.$Message.success('设置成功')
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>

<style lang="less" scoped>
.title {
    font-size: 16px;
    padding-left: 10px;
}
</style>
